var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979D9F",
    fillRule: "evenodd",
    d: "M16 14.869L14.869 16l-3.395-3.394 1.132-1.132L16 14.87zM6.4 11.2c-2.646 0-4.8-2.153-4.8-4.8 0-2.646 2.154-4.8 4.8-4.8s4.8 2.154 4.8 4.8c0 2.647-2.154 4.8-4.8 4.8zM6.4 0C2.866 0 0 2.866 0 6.4c0 3.534 2.866 6.4 6.4 6.4 3.534 0 6.4-2.866 6.4-6.4C12.8 2.866 9.934 0 6.4 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.4e61c89591a1dbafe3e347a411dc3712.svg";
export { ForwardRef as ReactComponent };